import { Text } from "rebass";
import { DynamicNextLink } from "./dynamic-next-link";
import styled from "styled-components";
import { buttonStyle } from "styled-system";

const Button = ({ text, link, variant = "border" }) => {
  return (
    <S_DynamicNextLink link={link} variant={variant}>
      <Text
        p={3}
        textAlign="center"
        fontFamily="medium"
        fontSize={1}
        letterSpacing={0.12}
      >
        {text}
      </Text>
    </S_DynamicNextLink>
  );
};

const S_DynamicNextLink = styled(DynamicNextLink)`
  ${buttonStyle};
  display: inline-block;
  min-width: 120px;

  a {
    display: block;
  }
`;

export { Button };
